// 'state' declare the initial state of the data storaged
const state = {
  // New Portfolio form modes:
  // 1 - new portfolio,
  // 2 - continue portfolio draft
  // 3 - edit an already created portfolio
  formMode: 1,
  // Used in edition or continue draft
  portfolioId: '',
  formOne: {
    email:'',
    investor_profile:'',
    contract_number:'',
    cutoff_date:'',
    alias:'',
    clientId: 0
  },
  formTwo: [],
  totalInvestment: '',
  advisorComment: '',
  percentageBasedForm: false
};

// 'getters' are useful to get the data from the store and reuse it in the components
const getters = {
  getGeneralData: state => state.formOne,
  getTransmitersData: state => state.formTwo,
  getFormMode: state => state.formMode,
  getSelectedPortfolio: state => state.portfolioId,
  getAdvisorComment: state => state.advisorComment,
  getFormValueTypes: state => state.percentageBasedForm,
  getTotalInvestmentAmount: state => state.totalInvestment
};

// 'actions' call the mutations
const actions = {
  saveGeneralData (context, data) {
    context.commit('updateDataFormOne', data)
  },
  saveInvestment(context, data) {
    context.commit('updateDataFormTwo', data)
  },
  deleteInvestment(context, data) {
    context.commit('removeFromDataFormTwo', data)
  },
  resetPortfolioForm(context,data) {
    context.commit('resetPortfolioForm', data)
  },
  preloadPortfolioForm(context, data) {
    context.commit('preloadPortfolioForm', data)
  },
  setFormMode(context, data) {
    context.commit('updateFormMode', data)
  },
  setSelectedPortfolio (context, data) {
    context.commit('updatePortfolioId', data)
  },
  setPercentageBasedForm (context, data) {
    context.commit('updateFormValueTypes', data)
  },
  setTotalInvestment (context, data) {
    context.commit ('updateTotalInvestment', data)
  }
}

// 'mutations' are the ones that modify the 'state'
const mutations = {
  updateDataFormOne(state, data) {
    state.formOne = data;
  },
  updateDataFormTwo(state, data) {
    state.formTwo.push(data)
  },
  updateFormValueTypes (state, data) {
    state.percentageBasedForm = data
  },
  updateTotalInvestment (state, data) {
    state.totalInvestment = data
  },
  removeFromDataFormTwo(state, data) {
    state.formTwo.splice(data, 1)
  },
  updateFormMode(state, data) {
    state.formMode = data
  },
  updatePortfolioId (state, data) {
    state.portfolioId = data
  },
  resetPortfolioForm(state) {
    state.formOne = {
      email:'',
      investor_profile:'',
      contract_number:'',
      cutoff_date:'',
      alias:'',
      clientId: 0
    }
    state.formTwo = []
    state.portfolioId = ''
    state.advisorComment = ''
    state.totalInvestment = ''
    state.percentageBasedForm = false
  },
  preloadPortfolioForm(state, data) {
    state.formTwo = []
    state.formOne = {
      email: data.client.email,
      contract_number: data.contractNumber,
      cutoff_date: data.cuttofDate,
      alias: data.client.alias,
      clientId: data.client.id
    }
    state.advisorComment = data.advisorComment
    const investments = data.investmentSet
    for (const item in investments) {
      const formattedInvestment = {
        assetClass: investments[item].asset.assetClass.id,
        assetClassLabel: investments[item].asset.assetClass.name,
        assetLabel: investments[item].asset.name,
        idAsset: investments[item].asset.id,
        price_of_note: investments[item].asset.price,
        totalAmount: investments[item].totalAmount,
        totalSecurities: investments[item].totalSecurities
      }
      state.formTwo.push(formattedInvestment)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
// Syntax to call the maps for the different
// import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'



// WEBPACK FOOTER //
// ./src/store/modules/data-info.js